import React from 'react'
import PropTypes from 'prop-types'
import { Button, Card } from 'reactstrap'
import { connect } from 'react-redux'


const RoadBookingSeatCard = ({ seat, onSelect, disabled, discount, soldSeats, onView }) => {

  const soldSeat = soldSeats.find(s => s.seatId === seat.id);

  const handleClick = () => {
    if (disabled || soldSeat) return;
    onSelect(seat);
  }

  const handleViewClick = (e) => {
    e.stopPropagation();
    onView(soldSeat);
  }

  return (
    <Card type="button" onClick={handleClick} className={`road-booking card-seat ${soldSeat ? 'disabled' : ''}`}>
      <div>
        <p className='road-booking seat-text'>Asiento {seat.seatNumber}</p>
      </div>
      {soldSeat && (
        <div>
          <small className='road-booking seat-text text-sm'>{soldSeat.firstName} {soldSeat.lastName}</small>
        </div>
      )}

      {
        !seat.isSold
          ? (
            <div>
              <p className='road-booking seat-text'>S/.{seat.price - discount}</p>
            </div>
          ) : (
            <div>
              <Button
                color="secondary"
                size="sm"
                onClick={handleViewClick}
              >
                Ver Boleto
              </Button>
            </div>
          )
      }

    </Card>
  )
}

RoadBookingSeatCard.propTypes = {
  seat: PropTypes.shape({
    id: PropTypes.number.isRequired,
    seatNumber: PropTypes.number.isRequired,
    xPosition: PropTypes.number.isRequired,
    yPosition: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    isSold: PropTypes.bool,
    seatMapElement: PropTypes.shape({
      name: PropTypes.string.isRequired,
      elementIcon: PropTypes.string.isRequired,
      isSeat: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  customer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }).isRequired,
  discount: PropTypes.number.isRequired,
  soldSeats: PropTypes.arrayOf(PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    seatId: PropTypes.number.isRequired,
    seatNumber: PropTypes.number.isRequired,
    itineraryId: PropTypes.number.isRequired,
  })).isRequired,
  onView: PropTypes.func.isRequired,
}

RoadBookingSeatCard.defaultProps = {
  disabled: false,
}

const mapStateToProps = ({ BookingUnit }) => {
  const discountCode = BookingUnit.Booking.getIn(['roadBooking', 'discount'])
  let discount = 0
  if (discountCode && !discountCode.isEmpty()) {
    discount = discountCode.get('maxAmount')
  }

  const soldSeatsStore = BookingUnit.Booking.getIn(['roadBooking', 'soldSeats'])

  const soldSeats = soldSeatsStore ? soldSeatsStore.toJS() : []

  return { discount, soldSeats }
}

export default connect(mapStateToProps)(RoadBookingSeatCard)
